<template>
  <div class="flex-container">
    <div class="flex-item" @click="openSliderLeft">
      <Badge :value="valuesCount" class="item filter-badge">
        <Button>
          <svgicon name="filtericon" class="icon" width="13" height="13" />Filter
        </Button>
      </Badge>
    </div>
    <div class="flex-item">
      <span v-for="(value,name) in valuesList" :key="name" :id="name">
        <Tag class="tag-default" size="small" effect="plain" v-if="value && value.length > 0">
          <span v-if="value.length === 1">{{value[0].name}}</span>
          <span v-else>{{value.length}} {{name}}s selected</span>
        </Tag>
        <Tag
          class="tag-default"
          size="small"
          effect="plain"
          v-else-if="value && !Array.isArray(value)"
        >
          <span>{{value.tlabel ? $t(value.tlabel) : value.name}}</span>
        </Tag>
      </span>
      <Tag class="tag-default" size="small" effect="plain" v-if="getFormattedDate">
        <span>{{getFormattedDate}}</span>
      </Tag>
    </div>
  </div>
</template>

<script>
import { formatDisplayDate } from '@/lib/Date';
export default {
  props: ['values'],
  computed: {
    valuesCount() {
      let count = Object.keys(this.values).reduce((accumulator, key) => {
        if( key !== 'startDate' && key!== 'endDate' && this.values[key]) {
          accumulator++;
        };
        return accumulator;
      }, 0);
      if(this.values['startDate'] && this.values['endDate']) {
        count++;
      }
      return count;
    },
    getFormattedDate() {
      return formatDisplayDate(this.values.startDate,this.values.endDate);
    },
    valuesList() {
      const filterTags = Object.assign({},this.values);
      delete filterTags['startDate'];
      delete filterTags['endDate'];
      return filterTags;
    },
  },
  methods: {
    openSliderLeft() {
      this.$emit('openSliderLeft');
    },
  },
};
</script>
